export enum GoalPriority {
  NOT_SET = 'NOT_SET',
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  P4 = 'P4',
  P5 = 'P5'
}
